import { IconButton } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { X } from 'ts-react-feather-icons';

type Props = {
  onClick?: () => void;
  renderInline?: boolean;
  overrideColor?: string;
};

type StyleProps = {
  overrideColor?: string;
};

const useStyles = (props: StyleProps) =>
  makeStyles((theme) => ({
    absoluteCloseButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: props.overrideColor ?? theme.palette.grey[500],
      zIndex: 999999,
    },
    inlineCloseButton: {
      color: theme.palette.grey[500],
      zIndex: 999999,
    },
  }));

export default function CloseX({ onClick, renderInline, overrideColor }: Props) {
  const classes = useStyles({ overrideColor })();
  return (
    <IconButton
      data-cy="close-modal"
      aria-label="close"
      className={renderInline ? classes.inlineCloseButton : classes.absoluteCloseButton}
      onClick={onClick}
      size="large"
    >
      <X />
    </IconButton>
  );
}
